"use strict";

exports.__esModule = true;
exports.default = removeAllSlides;

function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/cjs/components/core/manipulation/removeAllSlides.js
// module id = 88
// module chunks = 0